import { useEffect, useState } from 'react';
import { useReversalService } from '../../service/reversal';

const useGetReversalFormById = (id: string, isOrigin: boolean = false, reload = false) => {
  const {getReversalById} = useReversalService()
  const [data, setData] = useState<any>();
  const [error, setError] = useState<any>()
  const [isLoading, setIsLoading] = useState<Boolean>(false)
  useEffect(() => {
    setIsLoading(true)
  const fetchData = async () => {
    try {
      const response = await getReversalById(id,isOrigin);
      setData(response.data);
    } catch (err) {
      setError(err);
    }
    finally {
      setIsLoading(false)
    }
  };
  fetchData();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [reload]);

  return {
    data,
    error,
    isLoading
  };
};

export default useGetReversalFormById;
